import urlJoin from 'url-join';
import { getOptionFunc } from '../state';
export const reconcileApiUrl = (options, subPath) => {
    const getOption = getOptionFunc(options);
    const isProxiedEnv = getOption('medalliaConfig.isProxiedEnv');
    const medalliaHost = getOption('medalliaConfig.url');
    return isProxiedEnv ? urlJoin('/appswitcher/', subPath) : urlJoin(`${medalliaHost}`, '/apis/v1/', subPath);
};
